import { Grid } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import HeaderPage from "../../components/HeaderPage/Index";
import { isMobile } from "react-device-detect";
import {
  getData,
  storeData,
  clearData,
  getAllStorage,
  callChoice,
  addWarterMarker,
  checkHashImage,
  checkDipChipStatus,
} from "../../utils/GlobalHelper";
import { isEmpty } from "lodash";
import Loading from "../../components/loading/loading";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import PanelScrollBar from "../../components/BoxRightContent/PanelScrollBar";
import SummaryAccordion from "../../components/SummaryComponent/AccordionSum";
import moment from "moment";
import Configs from "../../constants/Configs";
import GlobalApi from "../../utils/GlobalApi";
import qs from "qs";
import DialogError from "../../components/CustomDialog/DialogCustoms";
import {
  CRSBirthAddressKey,
  CRSData,
  CRSDeclareLocationKey,
} from "../../utils/GlobalKey";

const header = {
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
    Accept: "application/json",
  },
};

const Summary = (props) => {
  const checkuserinfo = getData("checkuserinfo");
  const [lang, setLang] = useState(getData("lang"));
  const translations = getData("Translations");
  const [isLoading, setIsLoading] = useState(false);
  const [isEnabled, setIsEnabled] = useState(true);
  const [isModalError, setIsModalError] = useState(false);
  const [isModalErrorHash, setIsModalErrorHash] = useState(false);
  const [modalErrorTitle, setModalErrorTitle] = useState("ขออภัย");
  const [modalErrorDes, setModalErrorDes] = useState(
    "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง",
  );
  const [idc, setIdc] = useState([]);
  const [crsBirthAddress, setCRSBirthAddress] = useState([]);
  const [crsDeclareLocation, setCRSDeclareLocation] = useState([]);
  const [snapidcard, setSnapidcard] = useState([]);
  const [address, setAddress] = useState([]);
  const [career, setCareer] = useState([]);
  const [product, setProduct] = useState([]);
  const [status, setStatus] = useState([]);
  const [childList, setChildList] = useState([]);
  const [investIncome, setInvestIncome] = useState([]);
  const [investPurpose, setInvestPurpose] = useState([]);
  const [investAsset, setInvestAsset] = useState([]);
  const [attachSign, setAttachSign] = useState([]);
  const [imgHouse, setImgHouse] = useState([]);
  const [ats, setAts] = useState([]);
  const [jumpPage, setJumpPage] = useState(false);
  const [checkUpload, setCheckUpload] = useState(
    getData("checkUpload") ? getData("checkUpload") : false,
  );
  // LocalStorage data
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";
  const [editPage, setEditPage] = useState(getData("editPage"));
  const idcInfo = getData("idc");
  const crsBirthAddressInfo = getData(CRSBirthAddressKey);
  const crsDeclareLocationListInfo = getData(CRSData);
  const [uploadImg, setUploadImg] = useState("");
  const [uploadImgBase64, setUploadImgBase64] = useState("");
  const [uploadImgHash, setUploadImgHash] = useState("");
  const [uploadWaterImg, setUploadWaterImg] = useState("");
  let uploadImgSign = getData("uploadImageSign");
  let uploadImageHouse = getData("uploadImageHouse");
  const addrTxt = {
    idc: getData("text_idc_address"),
    cur: getData("text_current_address"),
    work: getData("text_workplace_address"),
    doc: getData("text_document_address"),
  };
  const careerTxt = getData("text_career");
  const statuss = getData("family_status");
  const childLists = getData("childList");
  const investIncomeTxt = getData("text_invest_income");
  const investPurposeTxt = getData("text_invest_purpose");
  const investAssetTxt = getData("text_invest_asset");
  const atsData = getData("f7_ats");
  let uploadImageBookBank = getData("uploadImageBookBank");
  const f7_bank_ats = getData("f7_bank_ats");
  const [close, setClose] = useState("");
  const [checkATS, setCheckATS] = useState(false);
  const unExpDate = getData("unExpDate");
  const checkJumpPage = async () => {
    const chkUserInfo = getData("checkuserinfo");
    const questions = getData("questionsAnswer");
    const pageAgree = getData("page_agree");
    const idcAddr = getData("f2_idc_address");
    const curAddr = getData("f2_current_address");
    const workAddr = getData("f2_workplace_address");
    const docAddr = getData("f2_document_address");
    const job = getData("f3_career");
    const income = getData("f3_source_income");
    const purpose = getData("f3_purpose_invest");
    const asset = getData("f3_asset");
    const suit = getData("suitability");
    await getImage();
    let productChoice = false;
    await callChoice(head_token).then((res) => {
      if (!isEmpty(res)) {
        res.forEach((e) => {
          e.items.forEach((item) => {
            if (item.selected === 1) productChoice = true;
          });
        });
      }
    });

    if (
      isEmpty(chkUserInfo) ||
      isEmpty(questions) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1 ||
      isEmpty(idcInfo) ||
      isEmpty(crsBirthAddressInfo) ||
      isEmpty(crsDeclareLocationListInfo) ||
      isEmpty(idcAddr) ||
      isEmpty(curAddr) ||
      isEmpty(workAddr) ||
      isEmpty(docAddr) ||
      isEmpty(job) ||
      !productChoice ||
      isEmpty(suit) ||
      isEmpty(statuss) ||
      isEmpty(childLists?.data) ||
      isEmpty(income) ||
      isEmpty(purpose) ||
      isEmpty(asset) ||
      isEmpty(uploadImgSign)
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getThaiFormatDate = async (value) => {
    if (!value) {
      return "";
    }
    const date = moment(value, "YYYYMMDD");
    const thaiMonth = {
      "01": "ม.ค.",
      "02": "ก.พ.",
      "03": "มี.ค.",
      "04": "เม.ย.",
      "05": "พ.ค.",
      "06": "มิ.ย.",
      "07": "ก.ค.",
      "08": "ส.ค.",
      "09": "ก.ย.",
      10: "ต.ค.",
      11: "พ.ย.",
      12: "ธ.ค.",
    };
    return `${date.format("DD")} ${thaiMonth[date.format("MM")]} ${date.format(
      "YYYY",
    )}`;
  };
  const callGetTitle = async () => {
    setIsLoading(true);
    let title = [];
    try {
      await GlobalApi.get(`${Configs.baseAPIURL03}/constant/title`)
        .then((res) => {
          if (!isEmpty(res.data)) {
            let data = res?.data?.Data;
            title = data;
          }
          setIsLoading(false);
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return title;
  };
  const callGetBank = async () => {
    setIsLoading(true);
    let bank = [];
    try {
      await GlobalApi.get(`${Configs.baseAPIURL03}/constant/bank`)
        .then((res) => {
          if (!isEmpty(res.data)) {
            let data = res?.data?.Data;
            bank = data;
          }
          setIsLoading(false);
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return bank;
  };

  const checkHash = async () => {
    const img = "data:image/jpeg;base64," + uploadImgBase64;
    const hashData = uploadImgHash;
    if (!isEmpty(img) && !isEmpty(hashData) && checkHashImage(img, hashData)) {
      await saveImageFrontCard(img);
    } else {
      setIsLoading(false);
      setIsModalErrorHash(true);
    }
  };
  const saveImageFrontCard = async (img) => {
    storeData("openSizeUploadImage", true);
    const image = uploadWaterImg;
    if (isEmpty(image)) {
      setIsLoading(false);
      setIsModalErrorHash(true);
      return;
    }

    clearData("openSizeUploadImage");
    const body = {
      head_token: getData("HeaderManp")?.head_token,
      id: "0",
      image_base64: image,
    };
    try {
      await GlobalApi.post(
        `${Configs.baseAPIURL03}/form/document/upload/idcard/front`,
        qs.stringify(body),
        header,
      )
        .then(async (res) => {
          setIsLoading(false);
          if (res?.data?.Data?.[0]?.[0]?.IsSuccess !== 1) {
            let mss =
              res.data.Data[0].MsgDesc !== ""
                ? res.data.Data[0].MsgDesc
                : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
            let title = "เกิดข้อผิดพลาด";
            setIsLoading(false);
            setIsModalError(true);
            setModalErrorTitle(title);
            setModalErrorDes(mss);
          } else {
            storeData("checkUpload", true);
            setCheckUpload(true);
          }
        })
        .catch((er) => {
          setIsLoading(false);
          let title = "เกิดข้อผิดพลาด";
          let mss =
            "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
            getData("api_error")?.message +
            ")";
          setIsModalError(true);
          setModalErrorTitle(title);
          setModalErrorDes(mss);
        });
    } catch (error) {
      setIsLoading(false);
      setIsModalError(true);
      setModalErrorTitle("เกิดข้อผิดพลาด");
      setModalErrorDes(
        "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
          getData("api_error")?.message +
          ")",
      );
    }
  };
  useEffect(() => {
    if (
      !isEmpty(uploadImg) &&
      !checkUpload &&
      !isEmpty(uploadImgBase64) &&
      !isEmpty(uploadImgHash)
    ) {
      checkHash();
      setSnapidcard([
        {
          title: "ภาพถ่ายบัตรประจำตัวประชาชน ",
          text: uploadImg,
        },
      ]);
    }
  }, [uploadImg, uploadImgBase64, uploadImgHash]);
  const getImage = async () => {
    setIsLoading(true);
    var postData = {
      head_token,
    };
    const queryString = new URLSearchParams(postData).toString();
    let getImage_url = `${Configs.baseURL}/api/getupload?` + queryString;
    try {
      await GlobalApi.get(getImage_url, header)
        .then(async (res) => {
          setIsLoading(false);
          if (res.data.api_status === "1") {
            if (res.data.data.length > 0) {
              res.data.data.forEach((element) => {
                if (element.tb_image_page === "uploadImage") {
                  setUploadWaterImg(element.watermark_image);
                  setUploadImgHash(element.hash_image);
                  setUploadImgBase64(element.tb_image_base64);
                  setUploadImg(
                    element.tb_image_type + "" + element.tb_image_base64,
                  );
                } else if (element.tb_image_page === "eSignature") {
                  uploadImgSign =
                    element.tb_image_type + element.tb_image_base64;
                } else if (element.tb_image_page === "uploadImageBookBank") {
                  uploadImageBookBank =
                    element.tb_image_type + element.tb_image_base64;
                } else if (element.tb_image_page === "uploadImageHouse") {
                  uploadImageHouse =
                    element.tb_image_type + element.tb_image_base64;
                }
              });
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
          setIsModalError(true);
          setModalErrorTitle("เกิดข้อผิดพลาด");
          setModalErrorDes(
            "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
              getData("api_error")?.message +
              ")",
          );
        });
    } catch (error) {
      setIsLoading(false);
      setIsModalError(true);
      setModalErrorTitle("เกิดข้อผิดพลาด");
      setModalErrorDes(
        "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
          getData("api_error")?.message +
          ")",
      );
    }
    return;
  };
  const onInitData = async () => {
    if (!isEmpty(idcInfo)) {
      let info = [];
      let group = [];
      info.push(idcInfo);
      await info.forEach((ele) => {
        let l = {};
        if (!isEmpty(ele)) {
          l.idc = ele.idCard;
          l.backIdc = ele.backIdCard;
          l.exp = ele.expireDateCard;
          l.nameTitle = ele.otherPrefixEN ? ele.otherPrefixEN : ele.prefixTH;
          l.fnameTh = ele.nameTH;
          l.midNameTh = ele.middlenameTH ? ele.middlenameTH : "-";
          l.lnameTh = ele.lastnameTH;
          l.fnameEn = ele.nameEN;
          l.midNameEn = ele.middlenameEN ? ele.middlenameEN : "-";
          l.lnameEn = ele.lastnameEN;
          l.nationality = ele.nationality["label"];
          l.bd = ele.birthday;
          l.phone = ele.phone;
          l.email = ele.email;
          group.push(l);
        }
      });
      if (!isEmpty(group)) {
        await group.forEach((ele) => {
          getThaiFormatDate(ele.exp).then((res) => {
            ele.exp = res;
          });
          getThaiFormatDate(ele.bd).then((res) => {
            ele.bd = res;
          });
        });
        await setIdc(group);
      }
    }

    setCRSBirthAddress([
      {
        countryTitle: "ประเทศที่เกิด",
        countryText: crsBirthAddressInfo.country.label,
        provinceTitle: "จังหวัด",
        provinceText: !isEmpty(crsBirthAddressInfo.province)
          ? crsBirthAddressInfo.province.label
          : null,
        birthCityTitle: "เมืองที่เกิด (ภาษาอังกฤษเท่านั้น)",
        birthCityText: !isEmpty(crsBirthAddressInfo.city)
          ? crsBirthAddressInfo.city
          : null,
      },
    ]);

    const titleNotaxList = [
      {
        notaxId: 1,
        title: "ประเทศที่ระบุข้างต้น ไม่ได้มีการออก เลขประจำตัวผู้เสียภาษี",
      },
      {
        notaxId: 2,
        title: "ยังไม่ได้รับหมายเลขประจำตัวผู้เสียภาษี",
      },
      {
        notaxId: 3,
        title: "ไม่จำเป็นต้องให้หรือเปิดเผยเลขประจําตัวผู้เสียภาษี",
      },
    ];

    setCRSDeclareLocation(
      crsDeclareLocationListInfo.map((item) => {
        if (item.checkNotax) {
          const selectedTitleNotax = titleNotaxList.find(
            (title) => title.notaxId === item.notaxId,
          );

          return {
            countryTitle: "ประเทศถิ่นที่อยู่ทางภาษี",
            countryText: item.country,
            descriptionTitle: "ไม่มีหมายเลขประจำตัวผู้เสียภาษี",
            descriptionText: selectedTitleNotax.title,
          };
        }

        return {
          countryTitle: "ประเทศถิ่นที่อยู่ทางภาษี",
          countryText: item.country,
          descriptionTitle: "หมายเลขประจำตัวผู้เสียภาษี",
          descriptionText: item.taxNumber,
        };
      }),
    );

    await clearData(CRSDeclareLocationKey);

    setAddress([
      {
        title: "ที่อยู่ตามบัตรประจำตัวประชาชน",
        text: addrTxt.idc,
        urls: "address/edit",
      },
      {
        title: "ที่อยู่ปัจจุบัน",
        text: addrTxt.cur,
        urls: "current_address/edit",
      },
      {
        title: "ที่อยู่ที่ทำงาน/ที่อยู่ที่สามารถติดต่อได้ ",
        text: addrTxt.work,
        urls: "workplace_address/edit",
      },
      {
        title: "ที่อยู่จัดส่งเอกสาร",
        text: addrTxt.doc,
        urls: "workplace_address/edit",
      },
    ]);

    setCareer([
      {
        title: "อาชีพ",
        text: careerTxt.career,
      },
      {
        title: "ประเภทธุรกิจ",
        text: careerTxt.busi,
      },
      {
        title: "รายได้ต่อเดือน (บาท)",
        text: careerTxt.income,
      },
      {
        title: "ตำแหน่งงาน",
        text: careerTxt.pos,
      },
      {
        title: "ชื่อสถานที่ทำงาน",
        text: careerTxt.office,
      },
    ]);

    setInvestIncome([
      {
        title: "ประเทศ",
        text: investIncomeTxt.source,
        checked: false,
      },
      {
        title: "แหล่งที่มาของรายได้",
        text: investIncomeTxt.employee,
        checked: investIncomeTxt.employee ? true : false,
      },
      {
        text: investIncomeTxt.heritage,
        checked: investIncomeTxt.heritage ? true : false,
      },
      {
        text: investIncomeTxt.saving,
        checked: investIncomeTxt.saving ? true : false,
      },
      {
        text: investIncomeTxt.invest,
        checked: investIncomeTxt.invest ? true : false,
      },
      {
        text: investIncomeTxt.retired,
        checked: investIncomeTxt.retired ? true : false,
      },
      {
        text: investIncomeTxt.business,
        checked: investIncomeTxt.business ? true : false,
      },
      {
        text: investIncomeTxt.other,
        checked: investIncomeTxt.other ? true : false,
      },
    ]);

    setInvestPurpose([
      {
        title: "จำนวนเงินที่คาดว่าจะนำมาลงทุนแต่ละครั้ง",
        text: investPurposeTxt.amount,
        checked: false,
      },
      {
        title: "วัตถุประสงค์การลงทุน",
        text: investPurposeTxt.short,
        checked: investPurposeTxt.short ? true : false,
      },
      {
        text: investPurposeTxt.long,
        checked: investPurposeTxt.long ? true : false,
      },
      {
        text: investPurposeTxt.tax,
        checked: investPurposeTxt.tax ? true : false,
      },
      {
        text: investPurposeTxt.retire,
        checked: investPurposeTxt.retire ? true : false,
      },
      {
        text: investPurposeTxt.other,
        checked: investPurposeTxt.other ? true : false,
      },
    ]);

    setInvestAsset([
      {
        title: "มูลค่าทรัพย์สินสุทธิ",
        text: investAssetTxt.valuable,
        checked: false,
      },
      {
        title: "ภาระทางการเงินต่อปี",
        text: investAssetTxt.outcome,
        checked: false,
      },
    ]);

    setAttachSign([
      {
        text: uploadImgSign,
      },
    ]);
    setImgHouse([
      {
        text: uploadImageHouse,
      },
    ]);
    let products = [];
    await callChoice(head_token).then((res) => {
      if (!isEmpty(res)) {
        products = res;
        setProduct(products);
      }
    });

    if (!isEmpty(statuss)) {
      let statusLists = [];
      let statusGroup = [];
      statusLists.push(statuss);
      await statusLists.forEach((ele) => {
        let l = {};
        if (!isEmpty(ele)) {
          if (ele.f1_marital_status !== "1") {
            if (ele.f1_spouse_is_th) {
              l.tile_spouse_is_th = "สัญชาติไทย";
              l.title_fname_th = "ชื่อ (ภาษาไทย)";
              l.title_lname_th = "นามสกุล (ภาษาไทย)";
            } else {
              l.tile_spouse_is_th = "ต่างชาติ";
            }
            l.title_name_title = "คำนำหน้าชื่อ";
            l.title_idc =
              "เลขที่บัตรประจำตัวประชาชน / หนังสือเดินทาง(กรณีต่างชาติ)";
            l.title_fname_en = "ชื่อ (ภาษาอังกฤษ)";
            l.title_lname_en = "นามสกุล (ภาษาอังกฤษ)";
            l.text_status = ele.f1_marital_status === "1" ? "โสด" : "สมรส";
            l.text_name_title =
              ele.f1_spouse_title !== "205"
                ? ele.f1_spouse_title
                : ele.f1_spouse_title_text;
            l.text_idc = ele.f1_spouse_id_card;
            l.text_fname_th = ele.f1_spouse_firstname;
            l.text_lname_th = ele.f1_spouse_lastname;
            l.text_fname_en = ele.f1_spouse_firstname_en;
            l.text_lname_en = ele.f1_spouse_lastname_en;
          } else {
            l.text_status = "โสด";
          }

          statusGroup.push(l);
        }
      });
      if (!isEmpty(statusGroup)) {
        await statusGroup.forEach((ele) => {
          if (ele.text_name_title !== "205") {
            callGetTitle().then((res) => {
              if (res) {
                res.forEach((e) => {
                  if (ele.text_name_title === e.Id) {
                    ele.text_name_title = e.NameTH;
                  }
                });
              }
            });
          }
        });
        setStatus(statusGroup);
      }
    }

    if (!isEmpty(childLists?.data)) {
      let childs = childLists.data;
      let childGroup = [];
      let i = 1;
      await childs.forEach((ele) => {
        let l = {};
        if (!isEmpty(ele.cardId)) {
          l.isHave = "มี";
          l.title = `บุตรคนที่ ${i++}`;
          l.title_idc = "เลขที่บัตรประจำตัวประชาชน";
          l.title_fname = "ชื่อ";
          l.title_lname = "นามสกุล";
          l.title_bd = "วันเดือนปีเกิด";
          l.text_idc = ele.cardId;
          l.text_fname = ele.firstName;
          l.text_lname = ele.lastName;
          l.text_bd = ele.birthDate;
          childGroup.push(l);
        }
      });
      if (!isEmpty(childGroup)) {
        await childGroup.forEach((ele) => {
          getThaiFormatDate(ele.text_bd).then((res) => {
            ele.text_bd = res;
          });
        });
        await setChildList(childGroup);
      } else {
        let l = {};
        let child = [];
        l.isHave = "ไม่มี";
        child.push(l);
        await setChildList(child);
      }
    }

    let atsInfo = [];
    if (!isEmpty(atsData)) {
      let l = {};
      let data = [];
      data.push(atsData);
      await data.forEach((ele) => {
        if (!isEmpty(ele.add_account_json)) {
          let accJson = ele.add_account_json;
          accJson.forEach((e) => {
            l.accName = e.SAfba_AccountName;
            l.accNo = e.SAfba_AccountNo;
            l.bankName = f7_bank_ats.ThName;
          });
        }
        l.other = ele.f7_isother;
      });
      if (!isEmpty(uploadImageBookBank) && l.other === "1") {
        l.uploadImageBookBank = uploadImageBookBank;
      }
      atsInfo.push(l);
      await callGetBank().then((res) => {
        if (res) {
          atsInfo.forEach((ele) => {
            res.forEach((e) => {
              if (ele.bankName === e.Id) {
                ele.bankName = e.ThName;
              }
            });
          });
          setAts(atsInfo);
        }
      });
    }
  };
  const closePanel = (value) => {
    setEditPage("");
    setClose(value);
  };
  const goBack = (e) => {
    clearData("editPage");
    storeData("back_form_ats", true);
    if (!isEmpty(atsData)) {
      // if (atsData.f7_isother === "0" || atsData.f7_isother === 0) {
      //   props.history.push("/attach_sign");
      // } else {
      //   if (!isEmpty(uploadImageBookBank)) {
      //     props.history.push("/attach_sign");
      //   } else {
      //     props.history.push("/ats_list");
      //   }
      // }
      props.history.push("/attach_sign");
    } else {
      props.history.push("/ats_list");
    }
  };
  const goPage = (value) => {
    storeData("currentStep", "summary");
    props.history.push(value);
  };
  const checkComeBack = (val) => {
    if (val) {
      props.history.push("/ats_list");
    }
  };
  const handleNext = async (e) => {
    e.preventDefault();
    if (!isEmpty(atsData)) {
      // if (atsData.f7_isother === "0" || atsData.f7_isother === 0) {
      //   await checkNdid();
      // } else {
      //   if (!isEmpty(uploadImageBookBank)) {
      //     await checkNdid();
      //   } else {
      //     setCheckATS(true);
      //     setModalErrorTitle("ข้อมูลไม่ครบถ้วน");
      //     setModalErrorDes("กรุณาตรวจสอบและดำเนินการใหม่อีกครั้ง");
      //     setIsModalError(true);
      //   }
      // }
      await checkEkycVerify();
    } else {
      setCheckATS(true);
      setModalErrorTitle("ข้อมูลไม่ครบถ้วน");
      setModalErrorDes("กรุณาตรวจสอบและดำเนินการใหม่อีกครั้ง");
      setIsModalError(true);
    }
  };
  const saveComeback = async (type) => {
    storeData("stamp_page", type);
    var last_stamp = JSON.stringify(await getAllStorage(type));
    const saveData = [
      {
        name: "comeback",
        url: `${Configs.baseAPIURL03}/form/comeback/manp`,
        postData: {
          head_token: head_token,
          last_stamp: last_stamp,
          stamp_page: type,
        },
      },
    ];
    setIsLoading(true);
    try {
      await GlobalApi.post(
        saveData[0].url,
        qs.stringify(saveData[0].postData),
        header,
      )
        .then((res) => {
          setIsLoading(false);
          if (res?.data?.Data?.[0]?.[0]?.IsSuccess !== 1) {
            let mss =
              res.data.Data[0].MsgDesc !== ""
                ? res.data.Data[0].MsgDesc
                : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
            let title = "เกิดข้อผิดพลาด";
            setIsLoading(false);
            setIsModalError(true);
            setModalErrorTitle(title);
            setModalErrorDes(mss);
          } else {
            clearData("currentStep");
            clearData("editPage");
            storeData("passedSummary", true);
            if (type === "NDID") {
              props.history.push("/ndid_information");
            } else if (type === "EKYC" || type === "SUMMARY") {
              props.history.push("/ekyc");
            } else if (type === "DIPCHIP") {
              props.history.push("/dipchip_waiting");
            } else if (type === "ThaID") {
              props.history.push("/thaid_condition");
            } else {
              props.history.push("/products_consent");
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
          let title = "เกิดข้อผิดพลาด";
          let mss =
            "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
            getData("api_error")?.message +
            ")";
          setIsModalError(true);
          setModalErrorTitle(title);
          setModalErrorDes(mss);
        });
    } catch (error) {
      setIsLoading(false);
      setIsModalError(true);
    }
  };
  const checkEkycVerify = async () => {
    setIsLoading(true);
    const header = {
      headers: {
        Accept: "application/json",
      },
    };
    const data = {
      head_token,
      id_card: idcInfo?.idCard,
    };

    try {
      const res = await GlobalApi.post(
        `${Configs.baseAPIURL03}/form/ekyc/verify`,
        data,
        header,
      );
      setIsLoading(false);
      const ic = getData("current_ic");
      const stamp_page = getData("stamp_page");
      if (res?.data?.Data?.[0]?.IsSuccess === 0) {
        clearData("currentStep");
        clearData("editPage");
        storeData("passedSummary", true);
        await checkDipChipStatus(
          head_token,
          { id_card: idcInfo?.idCard, aecode: ic.AECode },
          header,
        );
        const pageRoutes = {
          NDID: () => props.history.push("/ndid_information"),
          DIPCHIP: () => props.history.push("/dipchip_waiting"),
          CONFIRM: () => props.history.push("/products_consent"),
          ThaID: () => props.history.push("/thaid_condition"),
          EKYC: () => saveComeback("EKYC"),
          SUMMARY: () => saveComeback("EKYC"),
        };
        if (pageRoutes[stamp_page]) {
          pageRoutes[stamp_page]();
        } else {
          saveComeback("SUMMARY");
        }
      } else {
        const EkycChannel = res?.data?.Data?.[0]?.Data?.[0]?.EkycChannel;
        const ekycFlags = {
          DIPCHIP: "pass_dipchip",
          NDID: "pass_ndid",
          THAID: "pass_ThaID",
        };
        if (ekycFlags[EkycChannel]) {
          storeData(ekycFlags[EkycChannel], true);
        }
        saveComeback("CONFIRM");
      }
    } catch (error) {
      setIsLoading(false);

      let title_mss = "เกิดข้อผิดพลาด";
      let mss = "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";

      if (!!error.isAxiosError && !error.response) {
        // Keep default message
      } else if (error.response?.data?.Data?.[0]?.[0]) {
        const errData = error.response.data.Data[0][0];
        title_mss = errData.MsgDescTitle || title_mss;
        mss = errData.MsgDesc || mss;
      }

      setModalErrorTitle(title_mss);
      setModalErrorDes(mss);
      setIsModalError(true);
    }
  };

  useEffect(() => {
    checkJumpPage().then((res) => {
      if (res) {
        setJumpPage(true);
      } else {
        const saveComebackComplete = getData("saveComebackComplete");
        if (!isEmpty(saveComebackComplete)) {
          clearData("saveComebackComplete");
          onInitData();
        } else {
          if (!isEmpty(atsData)) {
            onInitData();
            // if (atsData.f7_isother === "0" || atsData.f7_isother === 0) {
            //   onInitData();
            // } else {
            //   props.history.push("/ats_list");
            // }
          } else {
            props.history.push("/ats_list");
          }
        }
      }
    });
  }, []);
  return (
    <>
      {jumpPage ? (
        <Grid className="app-splash-screen"></Grid>
      ) : (
        <>
          <HeaderPage
            title={translations?.[lang]?.home?.title}
            onChangeLang={(e) => setLang(e)}
            clickBack={(e) => (e ? goBack() : "")}
          />
          <Loading status={isLoading} />
          <DialogError
            open={isModalError}
            isModel={setIsModalError}
            title={modalErrorTitle}
            massage={modalErrorDes}
            switchType={(e) => checkComeBack(e)}
            btnPrimary={"ตกลง"}
          ></DialogError>
          <DialogError
            open={isModalErrorHash}
            isModel={setIsModalErrorHash}
            title={"เกิดข้อผิดพลาด"}
            massage={"ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง"}
            switchType={(e) => window.location.reload()}
            btnPrimary={"ลองใหม่อีกครั้ง"}
          ></DialogError>
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.summary}
                        clickBack={goBack}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={isMobile ? 16 : 9}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid className="content-main">
                        <Grid
                          className="box-right-content pb-3"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                          }}
                        >
                          <HeaderRight
                            title={translations?.[lang]?.summary?.title}
                          />
                          <PanelScrollBar
                            summary={true}
                            content={
                              <>
                                <Grid>
                                  <SummaryAccordion
                                    page="idc"
                                    lang={lang}
                                    // title="ข้อมูลตามบัตรประจำตัวประชาชน"
                                    title={translations?.[lang]?.summary?.idc}
                                    data={idc}
                                    closePnl={close}
                                    changeClose={closePanel}
                                  />
                                </Grid>
                                <Grid>
                                  <SummaryAccordion
                                    page="crsBirthAddress"
                                    url="birth_address/edit"
                                    lang={lang}
                                    // title="สถานที่เกิด"
                                    title={
                                      translations?.[lang]?.summary
                                        ?.crs_birthAddress
                                    }
                                    data={crsBirthAddress}
                                    edited={editPage}
                                    changePage={goPage}
                                    closePnl={close}
                                    changeClose={closePanel}
                                  />
                                </Grid>
                                <Grid>
                                  <SummaryAccordion
                                    page="crsDeclareLocation"
                                    url="declare_location/edit"
                                    lang={lang}
                                    // title="ถิ่นที่อยู่ทางภาษี"
                                    title={
                                      translations?.[lang]?.summary
                                        ?.crs_declare_location
                                    }
                                    data={crsDeclareLocation}
                                    edited={editPage}
                                    changePage={goPage}
                                    closePnl={close}
                                    changeClose={closePanel}
                                  />
                                </Grid>
                                <Grid>
                                  <SummaryAccordion
                                    page="snapidcard"
                                    url="snapidcard/edit"
                                    lang={lang}
                                    // title="การยืนยันตัวตน"
                                    title={
                                      translations?.[lang]?.summary?.snap_idc
                                    }
                                    data={snapidcard}
                                    edited={editPage}
                                    image={true}
                                    changePage={goPage}
                                    closePnl={close}
                                    changeClose={closePanel}
                                  />
                                </Grid>
                                {unExpDate && (
                                  <Grid>
                                    <SummaryAccordion
                                      page="house_registration"
                                      url="house_registration/edit"
                                      lang={lang}
                                      // title="การยืนยันตัวตน"
                                      title={"ทะเบียนบ้าน"}
                                      data={imgHouse}
                                      edited={editPage}
                                      image={true}
                                      changePage={goPage}
                                      closePnl={close}
                                      changeClose={closePanel}
                                    />
                                  </Grid>
                                )}
                                <Grid>
                                  <SummaryAccordion
                                    page="product_choice"
                                    url="products_choice/edit"
                                    lang={lang}
                                    // title="ประเภทบัญชี"
                                    title={
                                      translations?.[lang]?.summary
                                        ?.product_choice
                                    }
                                    data={product}
                                    edited={editPage}
                                    changePage={goPage}
                                    closePnl={close}
                                    changeClose={closePanel}
                                  />
                                </Grid>
                                <Grid>
                                  <SummaryAccordion
                                    page="address"
                                    lang={lang}
                                    multiBtn={true}
                                    // title="รายละเอียดที่อยู่ทั้งหมด"
                                    title={
                                      translations?.[lang]?.summary?.address
                                    }
                                    data={address}
                                    edited={editPage}
                                    changePage={goPage}
                                    closePnl={close}
                                    changeClose={closePanel}
                                  />
                                </Grid>
                                <Grid>
                                  <SummaryAccordion
                                    page="career"
                                    url="career/edit"
                                    lang={lang}
                                    // title="ข้อมูลอาชีพ"
                                    title={
                                      translations?.[lang]?.summary?.career
                                    }
                                    data={career}
                                    edited={editPage}
                                    changePage={goPage}
                                    closePnl={close}
                                    changeClose={closePanel}
                                  />
                                </Grid>
                                <Grid>
                                  <SummaryAccordion
                                    page="status"
                                    url="status/edit"
                                    lang={lang}
                                    // title="สถานภาพทางครอบครัว"
                                    title={
                                      translations?.[lang]?.summary?.status
                                    }
                                    data={status}
                                    edited={editPage}
                                    changePage={goPage}
                                    closePnl={close}
                                    changeClose={closePanel}
                                  />
                                </Grid>
                                <Grid>
                                  <SummaryAccordion
                                    page="childList"
                                    url="familystatuschild/edit"
                                    lang={lang}
                                    // title="บุตรที่ยังไม่บรรลุนิติภาวะ"
                                    title={
                                      translations?.[lang]?.summary?.childList
                                    }
                                    data={childList}
                                    edited={editPage}
                                    changePage={goPage}
                                    closePnl={close}
                                    changeClose={closePanel}
                                  />
                                </Grid>
                                <Grid>
                                  <SummaryAccordion
                                    page="invest_income"
                                    url="invest_info_income/edit"
                                    lang={lang}
                                    // title="ประเทศของแหล่งที่มาของรายได้/เงินลงทุน"
                                    title={
                                      translations?.[lang]?.summary
                                        ?.invest_income
                                    }
                                    data={investIncome}
                                    edited={editPage}
                                    checkIcon={investIncome ? true : false}
                                    changePage={goPage}
                                    closePnl={close}
                                    changeClose={closePanel}
                                  />
                                </Grid>
                                <Grid>
                                  <SummaryAccordion
                                    page="invest_purpose"
                                    url="invest_info_purpose/edit"
                                    lang={lang}
                                    // title="วัตถุประสงค์การลงทุน"
                                    title={
                                      translations?.[lang]?.summary
                                        ?.invest_purpose
                                    }
                                    data={investPurpose}
                                    edited={editPage}
                                    checkIcon={investPurpose ? true : false}
                                    changePage={goPage}
                                    closePnl={close}
                                    changeClose={closePanel}
                                  />
                                </Grid>
                                <Grid>
                                  <SummaryAccordion
                                    page="invest_asset"
                                    url="invest_info_asset/edit"
                                    lang={lang}
                                    // title="ข้อมูลการลงทุน"
                                    title={
                                      translations?.[lang]?.summary
                                        ?.invest_asset
                                    }
                                    data={investAsset}
                                    edited={editPage}
                                    changePage={goPage}
                                    closePnl={close}
                                    changeClose={closePanel}
                                  />
                                </Grid>
                                <Grid>
                                  <SummaryAccordion
                                    page="attach_sign"
                                    url="attach_sign/edit"
                                    lang={lang}
                                    // title="หลักฐานลายเซ็น"
                                    title={
                                      translations?.[lang]?.summary?.attach_sign
                                    }
                                    data={attachSign}
                                    edited={editPage}
                                    image={true}
                                    changePage={goPage}
                                    closePnl={close}
                                    changeClose={closePanel}
                                  />
                                </Grid>
                                <Grid>
                                  <SummaryAccordion
                                    page="ats"
                                    lang={lang}
                                    // title="สมัครบริการหักบัญชีอัตโนมัติ"
                                    title={translations?.[lang]?.ats?.title}
                                    data={ats}
                                    closePnl={close}
                                    changeClose={closePanel}
                                  />
                                </Grid>
                              </>
                            }
                          />{" "}
                          <ButtonRight
                            isDisbled
                            disbled={isEnabled}
                            text={translations?.[lang]?.summary?.next}
                            onNextPage={handleNext}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};
export default memo(Summary);
